(function () {
  const roots = document.querySelectorAll('[data-about-new]');
  if (!roots.length) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (v, lo = 0, hi = 1) => Math.min(Math.max(v, lo), hi);
  const lerp = (from, to, amount) => from + (to - from) * amount;
  const ease = (p) => p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;

  roots.forEach((root) => {
    const speedSetting = clamp(parseFloat(root.dataset.aboutWordSpeed || '35'), 10, 100);
    const speedRatio = (speedSetting - 10) / 90;
    // 1.0 = animation completes exactly when section bottom hits viewport bottom
    // >1.0 = finishes earlier; <1.0 = finishes later
    const wordProgressWindow = lerp(1.15, 0.65, speedRatio);
    const revealItems = root.querySelectorAll('.about-new__reveal');

    if ('IntersectionObserver' in window) {
      const obs = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -16% 0px', threshold: 0.16 }
      );
      revealItems.forEach((el) => obs.observe(el));
    } else {
      revealItems.forEach((el) => el.classList.add('is-visible'));
    }

    const counters = root.querySelectorAll('[data-about-count]');
    const parseStat = (value) => {
      const raw = (value || '').trim();
      const match = raw.match(/^([^0-9+\-.,]*)([+\-]?(?:\d[\d,]*|\d)(?:\.\d+)?)(.*)$/);
      if (!match) return null;

      const target = Number(match[2].replace(/,/g, ''));
      if (!Number.isFinite(target)) return null;

      return {
        prefix: match[1],
        suffix: match[3],
        target,
        decimals: (match[2].split('.')[1] || '').length,
        comma: match[2].includes(',')
      };
    };

    const formatStat = (stat, value) => {
      const fixed = value.toFixed(stat.decimals);
      const formatted = stat.comma ? fixed.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : fixed;
      return `${stat.prefix}${formatted}${stat.suffix}`;
    };

    const animateCounter = (counter) => {
      const stat = parseStat(counter.dataset.aboutCount);
      if (!stat || reduceMotion) return;

      const duration = 1800;
      const start = performance.now();
      const tick = (now) => {
        const p = Math.min((now - start) / duration, 1);
        counter.textContent = formatStat(stat, stat.target * ease(p));
        if (p < 1) requestAnimationFrame(tick);
      };

      counter.textContent = formatStat(stat, 0);
      requestAnimationFrame(tick);
    };

    if ('IntersectionObserver' in window) {
      const cObs = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            animateCounter(entry.target);
            cObs.unobserve(entry.target);
          });
        },
        { threshold: 0.35 }
      );
      counters.forEach((counter) => cObs.observe(counter));
    }

    const wordSections = [...root.querySelectorAll('[data-about-words]')].map((section) => ({
      section,
      title: section.querySelector('.about-new__word-title'),
      letters: [...section.querySelectorAll('[data-about-letter]')]
    }));
    const stepsEl = root.querySelector('[data-about-steps]');
    const communityEl = root.querySelector('[data-about-community]');

    if (reduceMotion) {
      wordSections.forEach(({ letters }) => {
        letters.forEach((letter) => letter.classList.add('is-active'));
      });

      if (stepsEl) {
        stepsEl.querySelectorAll('[data-about-step-frame]')[0]?.classList.add('is-active');
        stepsEl.querySelectorAll('[data-about-step-num]')[0]?.classList.add('is-active');
        stepsEl.querySelectorAll('[data-about-step-title]')[0]?.classList.add('is-active');
        stepsEl.querySelectorAll('[data-about-step-desc]')[0]?.classList.add('is-active');
      }

      if (communityEl) {
        communityEl.querySelectorAll('[data-about-gallery-item]').forEach((item) => {
          item.style.opacity = '1';
          item.style.transform = 'translate3d(0, 0, 0)';
        });
        communityEl.querySelector('[data-about-gallery-title]')?.classList.add('is-visible');
        communityEl.querySelectorAll('[data-about-gallery-fade]').forEach((el) => el.classList.add('is-visible'));
      }

      root.querySelectorAll('.about-new__step-stacked-image, .about-new__step-stacked-num, .about-new__step-stacked-title, .about-new__step-stacked-desc')
        .forEach((el) => el.classList.add('is-visible'));

      return;
    }

    const stackedCards = [...root.querySelectorAll('.about-new__step-stacked')];
    if (stackedCards.length && 'IntersectionObserver' in window) {
      const cardObs = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const delays = [0, 120, 230, 340];
            [
              entry.target.querySelector('.about-new__step-stacked-image'),
              entry.target.querySelector('.about-new__step-stacked-num'),
              entry.target.querySelector('.about-new__step-stacked-title'),
              entry.target.querySelector('.about-new__step-stacked-desc')
            ].forEach((child, i) => {
              if (!child) return;
              setTimeout(() => child.classList.add('is-visible'), delays[i]);
            });
            cardObs.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
      );
      stackedCards.forEach((card) => cardObs.observe(card));
    }

    const parallaxItems = root.querySelectorAll('[data-about-parallax]');

    const updateWords = () => {
      wordSections.forEach(({ section, letters }) => {
        if (!letters.length) return;

        const rect = section.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;

        // progress=0: heading reaches the reading area
        // progress=1: the final word reaches full contrast
        const triggerOffset = window.innerHeight * (window.innerWidth < 750 ? 0.86 : 0.78); const progress = rect.height > 0 ? clamp((triggerOffset - rect.top) / (rect.height * wordProgressWindow)) : 0;

        // overlap controls how many letters are mid-fade at any moment (wave thickness)
        // stride+fadeWidth chosen so the LAST letter completes its fade exactly at progress=1
        const N = letters.length;
        const overlap = 2.5;
        const stride = 1 / (N - 1 + overlap);
        const fadeWidth = stride * overlap;

        letters.forEach((letter, index) => {
          const letterStart = index * stride;
          const p = clamp((progress - letterStart) / fadeWidth);
          const alpha = p <= 0 ? 0.18 : p >= 1 ? 1 : 0.18 + ease(p) * 0.82;

          letter.style.color = `rgba(17, 17, 17, ${alpha.toFixed(3)})`;
          letter.classList.toggle('is-active', p >= 1);
        });
      });
    };

    const stepFrames = stepsEl ? [...stepsEl.querySelectorAll('[data-about-step-frame]')] : [];
    const stepNums = stepsEl ? [...stepsEl.querySelectorAll('[data-about-step-num]')] : [];
    const stepTitles = stepsEl ? [...stepsEl.querySelectorAll('[data-about-step-title]')] : [];
    const stepDescs = stepsEl ? [...stepsEl.querySelectorAll('[data-about-step-desc]')] : [];
    const stepCount = stepFrames.length;

    const setActive = (lists, index) => {
      lists.forEach((list) => list.forEach((el, i) => el.classList.toggle('is-active', i === index)));
    };

    const updateSteps = () => {
      if (!stepsEl || !stepCount) return;
      const rect = stepsEl.getBoundingClientRect();
      const viewH = window.innerHeight;
      const scrolled = -rect.top;
      // Useful sticky-scroll range = container height minus one viewport
      const scrollRange = Math.max(rect.height - viewH, 1);
      const stepShare = scrollRange / stepCount;
      // Lead each trigger by 18% of a step so the LAST step lingers (gives the 0.9s CSS fade time to complete before the section unsticks)
      // On mobile, reduce the lead so steps don't fire too early on a fast swipe
      const isMobile = window.innerWidth < 750;
      const lead = stepShare * (isMobile ? 0.06 : 0.18);
      const active = clamp(Math.floor((scrolled + lead) / stepShare), 0, stepCount - 1);
      setActive([stepFrames, stepNums, stepTitles, stepDescs], active);
    };

    const galleryItems = communityEl ? [...communityEl.querySelectorAll('[data-about-gallery-item]')] : [];
    const galleryTitle = communityEl?.querySelector('[data-about-gallery-title]');
    const galleryFades = communityEl ? [...communityEl.querySelectorAll('[data-about-gallery-fade]')] : [];

    const updateGallery = () => {
      if (!communityEl) return;

      const rect = communityEl.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;

      const maxScroll = communityEl.offsetHeight - window.innerHeight;
      const targetP = maxScroll > 0 ? clamp(-rect.top / maxScroll) : 0;
      const previousP = parseFloat(communityEl.dataset.smoothProgress);
      const p = isNaN(previousP) ? targetP : lerp(previousP, targetP, 0.18);
      communityEl.dataset.smoothProgress = p.toFixed(4);

      const titleOp = p < 0.08 ? 0
        : p < 0.24 ? ease((p - 0.08) / 0.16)
        : p < 0.82 ? 1
        : p < 0.96 ? ease((0.96 - p) / 0.14)
        : 0;

      if (galleryTitle) {
        galleryTitle.style.opacity = titleOp.toFixed(3);
        galleryTitle.classList.toggle('is-visible', titleOp > 0.5);
      }

      galleryFades.forEach((el) => {
        el.style.opacity = titleOp.toFixed(3);
        el.classList.toggle('is-visible', titleOp > 0.5);
      });

      galleryItems.forEach((item, index) => {
        const total = Math.max(galleryItems.length - 1, 1);
        const flightStart = 0.06 + (index / total) * 0.68;
        const flightDuration = window.innerWidth < 750 ? 0.34 : 0.3;
        const rawP = (p - flightStart) / flightDuration;
        const itemP = ease(clamp(rawP));
        const fadeIn = ease(clamp(rawP / 0.22));
        const fadeOut = 1 - ease(clamp((rawP - 0.58) / 0.42));
        const itemX = parseFloat(item.dataset.x || '50');
        const itemY = parseFloat(item.dataset.y || '50');
        const minX = window.innerWidth < 750 ? 18 : 12;
        const maxX = window.innerWidth < 750 ? 82 : 88;
        const minY = window.innerWidth < 750 ? 18 : 12;
        const maxY = window.innerWidth < 750 ? 80 : 86;
        const finalX = clamp(itemX, minX, maxX);
        const finalY = clamp(itemY, minY, maxY);
        const side = finalX < 50 ? -1 : 1;
        const verticalSide = finalY < 50 ? -1 : 1;
        const depth = (index % 3) * 34;
        const startScale = window.innerWidth < 750 ? 0.36 : 0.3;
        const edgeInset = Math.abs(finalX - itemX) + Math.abs(finalY - itemY);
        const endScale = (window.innerWidth < 750 ? 1.34 : 1.48) - Math.min(edgeInset * 0.006, 0.08);
        const scale = lerp(startScale, endScale, itemP) + depth / 850;
        const centerX = 50 - itemX + side * ((index % 2 ? 1 : -1) * (window.innerWidth < 750 ? 5 : 7));
        const centerY = 50 - itemY + verticalSide * ((index % 3) - 1) * (window.innerWidth < 750 ? 4 : 5);
        const passX = finalX - itemX + side * (window.innerWidth < 750 ? 8 : 11);
        const passY = finalY - itemY + verticalSide * (window.innerWidth < 750 ? 5 : 7);
        const exitX = finalX - itemX + side * (window.innerWidth < 750 ? 24 : 34);
        const exitY = finalY - itemY + verticalSide * (window.innerWidth < 750 ? 16 : 22);
        const flyX = lerp(centerX, passX, itemP);
        const flyY = lerp(centerY, passY, itemP);
        const opacity = Math.max(0, Math.min(fadeIn, fadeOut)) * (window.innerWidth < 750 ? 0.68 : 0.74);

        item.style.transform = `translate3d(${flyX.toFixed(2)}vw, ${flyY.toFixed(2)}vh, ${depth}px) scale(${scale.toFixed(3)})`;
        item.style.opacity = Math.max(0, opacity).toFixed(3);
      });
    };

    let ticking = false;

    const updateAll = () => {
      parallaxItems.forEach((item) => {
        if (window.innerWidth < 750) {
          item.style.transform = '';
          item.dataset.smoothOffset = '0';
          return;
        }
        const speed = parseFloat(item.dataset.parallaxSpeed || '0.1') * 0.54;
        const rect = item.getBoundingClientRect();
        const target = (rect.top - window.innerHeight / 2) * speed;
        const current = parseFloat(item.dataset.smoothOffset || '0');
        const smooth = lerp(current, target, 0.065);

        item.dataset.smoothOffset = smooth.toFixed(3);
        item.style.transform = `translate3d(0, ${smooth}px, 0)`;
      });

      updateWords();
      updateSteps();
      updateGallery();
      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateAll);
    };

    window.addEventListener('scroll', () => {
      requestUpdate();
    }, { passive: true });

    window.addEventListener('resize', requestUpdate, { passive: true });
    requestUpdate();
  });
})();
